import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { getPermissions } from '@/redux/permissions/selectors';
import { selectAccountSlug } from '@/redux/session/selectors';
import { trackEvent } from '@/segment/segment';
import { actions } from '@/shared/types/permissions';
import { EventName } from '@/shared/types/segment';
import { RootState } from '@/shared/types/state';

interface UpgradePlanDescriptionProps {
  i18nKey: string;
  values?: Record<string, unknown>;
}

export const UpgradePlanDescription = ({ i18nKey, values }: UpgradePlanDescriptionProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);
  const canReadBilling = useSelector((state: RootState) =>
    getPermissions(state, 'billing', actions.READ)
  );

  return (
    <p className="text-xs leading-5 text-muted-foreground">
      {canReadBilling ? (
        <Trans
          i18nKey={i18nKey}
          values={values}
          components={{
            upgradePlanLink: (
              <Link
                to={`/${slug}/account/billing`}
                className="font-medium text-primary"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackEvent(EventName.ClickUpgradePlan);
                }}
              />
            ),
          }}
        />
      ) : (
        t('billing.contact_admin_to_upgrade')
      )}
    </p>
  );
};
